/** Latest broking margin sheet — shared across broking marketing sections */
export const BROKING_MARGIN_SHEET_URL =
    "https://docs.google.com/spreadsheets/d/1oBAByknMHEgxVhaakMy8qH9W4f4pMyzGDw87erG-CeM/edit?gid=503182190#gid=503182190";
